// AssigneeSelector.js
import React, { useState } from "react";

const AssigneeSelector = ({
  assignees,
  selectedAssignees,
  setSelectedAssignees,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const toggleAssignee = (assigneeId) => {
    if (selectedAssignees.includes(assigneeId)) {
      setSelectedAssignees(selectedAssignees.filter((id) => id !== assigneeId));
    } else {
      setSelectedAssignees([...selectedAssignees, assigneeId]);
    }
  };

  const filteredAssignees = assignees.filter((assignee) =>
    assignee.displayName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <input
        type="text"
        className="w-full p-2 border rounded-lg mb-4"
        placeholder="Search users..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {filteredAssignees.length > 0 && (
        <div className="flex flex-wrap gap-4">
          {filteredAssignees.map((assignee) => {
            const isSelected = selectedAssignees.includes(assignee.uid);
            return (
              <div
                key={assignee.uid}
                className={`cursor-pointer p-2 border rounded-lg flex items-center gap-2 ${
                  isSelected ? "bg-blue-100 border-blue-500" : "border-gray-300"
                }`}
                onClick={() => toggleAssignee(assignee.uid)}
              >
                <img
                  src={
                    assignee.profileImage || "https://via.placeholder.com/40"
                  }
                  alt={assignee.displayName}
                  className="w-8 h-8 rounded-full object-cover"
                />
                <span>{assignee.displayName}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AssigneeSelector;
